// start:ng42.barrel
export * from './data-access.constants';
export * from './data-access.module';
export * from './data-access.service';
export * from './+state';
export * from './format-days-as-years.util';
// end:ng42.barrel

